<template>
  <ModalLayout :size="size" class="c-confirmation-modal">
    <template #header>
      {{ title }}
    </template>
    <template #body>
      <p class="c-confirmation-modal__text">{{ text }}</p>
      <div class="c-confirmation-modal__row">
        <div v-if="cancelButton" class="c-confirmation-modal__button-wrapper">
          <RouterButton variant="cancel" tabindex="0" :aria-label="$t('ARIA.CANCEL')" @click="cancelButtonEvent">
            {{ cancelButton }}
          </RouterButton>
        </div>
        <div class="c-confirmation-modal__button-wrapper">
          <RouterButton variant="secondary" :aria-label="$t('ARIA.OK')" @click="okButtonEvent">
            {{ okButton }}
          </RouterButton>
        </div>
      </div>
    </template>
  </ModalLayout>
</template>

<script setup lang="ts">
import ModalLayout from '@/components/layout/modal/ModalLayout.vue';
import RouterButton from '@/components/RouterButton.vue';
import useAnalytics from '@/services/useAnalytics';
import { AnalyticsAction, AnalyticsCategory } from '@/types/enums/analytics.enum';
import useModal from '@/services/useModal';

interface ConfirmationModalProps {
  title: string;
  text: string;
  cancelButton: string;
  okButton: string;
  size?: string;
}

withDefaults(defineProps<ConfirmationModalProps>(), {
  size: 'md',
});

const emit = defineEmits<{
  confirm: [];
}>();

const { close } = useModal();
const { createEvent } = useAnalytics();
const analytics = createEvent();
analytics.action(AnalyticsAction.CLICK).category(AnalyticsCategory.BUTTON);

const cancelButtonEvent = () => {
  analytics.label('cancel button').track();
  close();
};

const okButtonEvent = () => {
  analytics.label('ok button').track();
  emit('confirm');
  close();
};
</script>
